import { render, staticRenderFns } from "./CourseCreateAndEditDialog.vue?vue&type=template&id=0c58db3e&scoped=true"
import script from "./CourseCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./CourseCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseCreateAndEditDialog.vue?vue&type=style&index=0&id=0c58db3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58db3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
